module.exports = __webpack_public_path__ + "img/damagenotice.f865b814.svg";